module.exports = __webpack_public_path__ + "img/40_38_035_330.58ad0786.jpg";